<div class="spinner-wrliber" [ngStyle]="{'display': showSpinner ? 'flex' : 'none'}"
    [style.backgroundColor]="transparencyColor">
    <div class="spinner" style="position: relative;" [ngClass]="{ 'show-spinner': showSpinner }">

        <div [ngSwitch]="loader">

            <simple-spinner *ngSwitchCase="'simple-spinner'" [thickness]="thickness" [width]="width"
                [primaryColor]="primaryColor" [secondaryColor]="secondaryColor">
            </simple-spinner>

            <inner-arc *ngSwitchCase="'inner-arc'" [thickness]="thickness" [width]="width" [primaryColor]="primaryColor"
                [secondaryColor]="secondaryColor">
            </inner-arc>

            <outer-arc *ngSwitchCase="'outer-arc'" [thickness]="thickness" [width]="width" [primaryColor]="primaryColor"
                [secondaryColor]="secondaryColor">
            </outer-arc>

            <twin-inner-arc *ngSwitchCase="'twin-inner-arc'" [thickness]="thickness" [width]="width"
                [primaryColor]="primaryColor" [secondaryColor]="secondaryColor">
            </twin-inner-arc>

            <twin-outer-arc *ngSwitchCase="'twin-outer-arc'" [thickness]="thickness" [width]="width"
                [primaryColor]="primaryColor" [secondaryColor]="secondaryColor">
            </twin-outer-arc>

            <inner-orbiting-dot *ngSwitchCase="'inner-orbiting-dot'" [thickness]="thickness" [width]="width"
                [primaryColor]="primaryColor" [secondaryColor]="secondaryColor">
            </inner-orbiting-dot>

            <outer-orbiting-dot *ngSwitchCase="'outer-orbiting-dot'" [thickness]="thickness" [width]="width"
                [primaryColor]="primaryColor" [secondaryColor]="secondaryColor">
            </outer-orbiting-dot>

            <inner-spiral *ngSwitchCase="'inner-spiral'" [thickness]="thickness" [width]="width"
                [primaryColor]="primaryColor" [secondaryColor]="secondaryColor">
            </inner-spiral>

            <dual-segment *ngSwitchCase="'dual-segment'" [thickness]="thickness" [width]="width"
                [primaryColor]="primaryColor" [secondaryColor]="secondaryColor">
            </dual-segment>

            <dotted-circular *ngSwitchCase="'dotted-circular'" [thickness]="thickness" [width]="width"
                [primaryColor]="primaryColor" [secondaryColor]="secondaryColor">
            </dotted-circular>

            <rotating-bar *ngSwitchCase="'rotating-bar'" [thickness]="thickness" [width]="width"
                [primaryColor]="primaryColor" [secondaryColor]="secondaryColor">
            </rotating-bar>

            <ring *ngSwitchCase="'ring'" [thickness]="thickness" [width]="width" [primaryColor]="primaryColor"
                [secondaryColor]="secondaryColor">
            </ring>

            <square-wave *ngSwitchCase="'square-wave'" [thickness]="thickness" [width]="width"
                [primaryColor]="primaryColor" [secondaryColor]="secondaryColor">
            </square-wave>

            <glowing-ring *ngSwitchCase="'glowing-ring'" [thickness]="thickness" [width]="width"
                [primaryColor]="primaryColor" [secondaryColor]="secondaryColor">
            </glowing-ring>

            <half-ring *ngSwitchCase="'half-ring'" [thickness]="thickness" [width]="width" [primaryColor]="primaryColor"
                [secondaryColor]="secondaryColor">
            </half-ring>

            <intersecting-ring *ngSwitchCase="'intersecting-ring'" [thickness]="thickness" [width]="width"
                [primaryColor]="primaryColor" [secondaryColor]="secondaryColor">
            </intersecting-ring>

            <balancing-shapes *ngSwitchCase="'balancing-shapes'" [thickness]="thickness" [width]="width"
                [primaryColor]="primaryColor" [secondaryColor]="secondaryColor">
            </balancing-shapes>

            <rotating-slice *ngSwitchCase="'rotating-slice'" [thickness]="thickness" [width]="width"
                [primaryColor]="primaryColor" [secondaryColor]="secondaryColor">
            </rotating-slice>

            <inner-fill-arc *ngSwitchCase="'inner-fill-arc'" [thickness]="thickness" [width]="width"
                [primaryColor]="primaryColor" [secondaryColor]="secondaryColor">
            </inner-fill-arc>

            <rolling-circle *ngSwitchCase="'rolling-circle'" [thickness]="thickness" [width]="width"
                [primaryColor]="primaryColor" [secondaryColor]="secondaryColor">
            </rolling-circle>

            <orbiting-dots *ngSwitchCase="'orbiting-dots'" [thickness]="thickness" [width]="width"
                [primaryColor]="primaryColor" [secondaryColor]="secondaryColor">
            </orbiting-dots>

            <dual-pulsating-dots *ngSwitchCase="'dual-pulsating-dots'" [thickness]="thickness" [width]="width"
                [primaryColor]="primaryColor" [secondaryColor]="secondaryColor">
            </dual-pulsating-dots>

            <expanding-dots *ngSwitchCase="'expanding-dots'" [thickness]="thickness" [width]="width"
                [primaryColor]="primaryColor" [secondaryColor]="secondaryColor">
            </expanding-dots>

            <rotating-double-square *ngSwitchCase="'rotating-double-square'" [thickness]="thickness" [width]="width"
                [primaryColor]="primaryColor" [secondaryColor]="secondaryColor">
            </rotating-double-square>

            <scattered-diamond *ngSwitchCase="'scattered-diamond'" [thickness]="thickness" [width]="width"
                [primaryColor]="primaryColor" [secondaryColor]="secondaryColor">
            </scattered-diamond>

            <pulsating-grid *ngSwitchCase="'pulsating-grid'" [thickness]="thickness" [width]="width"
                [primaryColor]="primaryColor" [secondaryColor]="secondaryColor">
            </pulsating-grid>

            <expanding-square *ngSwitchCase="'expanding-square'" [thickness]="thickness" [width]="width"
                [primaryColor]="primaryColor" [secondaryColor]="secondaryColor">
            </expanding-square>

            <tilted-bar *ngSwitchCase="'tilted-bar'" [thickness]="thickness" [width]="width"
                [primaryColor]="primaryColor" [secondaryColor]="secondaryColor">
            </tilted-bar>

            <bouncing-diamond *ngSwitchCase="'bouncing-diamond'" [thickness]="thickness" [width]="width"
                [primaryColor]="primaryColor" [secondaryColor]="secondaryColor">
            </bouncing-diamond>

            <intersecting-triangle *ngSwitchCase="'intersecting-triangle'" [thickness]="thickness" [width]="width"
                [primaryColor]="primaryColor" [secondaryColor]="secondaryColor">
            </intersecting-triangle>

            <rotating-triangle *ngSwitchCase="'rotating-triangle'" [thickness]="thickness" [width]="width"
                [primaryColor]="primaryColor" [secondaryColor]="secondaryColor">
            </rotating-triangle>

            <bouncing-square *ngSwitchCase="'bouncing-square'" [thickness]="thickness" [width]="width"
                [primaryColor]="primaryColor" [secondaryColor]="secondaryColor">
            </bouncing-square>

            <spin-with-bounce *ngSwitchCase="'spin-with-bounce'" [thickness]="thickness" [width]="width"
                [primaryColor]="primaryColor" [secondaryColor]="secondaryColor">
            </spin-with-bounce>

            <circle-inside-square *ngSwitchCase="'circle-inside-square'" [thickness]="thickness" [width]="width"
                [primaryColor]="primaryColor" [secondaryColor]="secondaryColor">
            </circle-inside-square>

            <vertical-bars-pulsation *ngSwitchCase="'vertical-bars-pulsation'" [thickness]="thickness" [width]="width"
                [primaryColor]="primaryColor" [secondaryColor]="secondaryColor">
            </vertical-bars-pulsation>

            <flipping-parallel-lines *ngSwitchCase="'flipping-parallel-lines'" [thickness]="thickness" [width]="width"
                [primaryColor]="primaryColor" [secondaryColor]="secondaryColor">
            </flipping-parallel-lines>

            <rising-bars-with-dot *ngSwitchCase="'rising-bars-with-dot'" [thickness]="thickness" [width]="width"
                [primaryColor]="primaryColor" [secondaryColor]="secondaryColor">
            </rising-bars-with-dot>

            <dashed-line-expansion *ngSwitchCase="'dashed-line-expansion'" [thickness]="thickness" [width]="width"
                [primaryColor]="primaryColor" [secondaryColor]="secondaryColor">
            </dashed-line-expansion>

            <balancing-capsule *ngSwitchCase="'balancing-capsule'" [thickness]="thickness" [width]="width"
                [primaryColor]="primaryColor" [secondaryColor]="secondaryColor">
            </balancing-capsule>

            <loading-bounce *ngSwitchCase="'loading-bounce'" [thickness]="thickness" [width]="width"
                [primaryColor]="primaryColor" [secondaryColor]="secondaryColor">
            </loading-bounce>

            <expanding-block *ngSwitchCase="'expanding-block'" [thickness]="thickness" [width]="width"
                [primaryColor]="primaryColor" [secondaryColor]="secondaryColor">
            </expanding-block>

            <arc-of-dots *ngSwitchCase="'arc-of-dots'" [thickness]="thickness" [width]="width"
                [primaryColor]="primaryColor" [secondaryColor]="secondaryColor">
            </arc-of-dots>

            <rotating-pie-shape *ngSwitchCase="'rotating-pie-shape'" [thickness]="thickness" [width]="width"
                [primaryColor]="primaryColor" [secondaryColor]="secondaryColor">
            </rotating-pie-shape>

            <circular-progress *ngSwitchCase="'circular-progress'" [thickness]="thickness" [width]="width"
                [primaryColor]="primaryColor" [secondaryColor]="secondaryColor">
            </circular-progress>

            <bouncing-dots *ngSwitchCase="'bouncing-dots'" [thickness]="thickness" [width]="width"
                [primaryColor]="primaryColor" [secondaryColor]="secondaryColor">
            </bouncing-dots>


            <div *ngSwitchDefault>
                <ng-content></ng-content>
            </div>

        </div>
    </div>
</div>